// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3woBn","inputDescription":"styles_inputDescription__2XyO6"};